<div>
  <div class="heroWrapper Upper_wrapper">
    <div class="backdrop Genre_heading">
      <h1 class="headingWL">Choose what you<span> enjoy the most</span></h1>
      <h2 class="headingWL">Find your<span> Happiness</span></h2>
    </div>
    <!-- <div class="search_wrapper">
      <input
        type="search"
        class="search_input"
        placeholder="Enter Course name"
      />
      <input type="search" class="select_genre" placeholder="Select Genre" />
      <button type="submit" class="submit_btn">Search</button>
    </div> -->
  </div>
  <div class="d-flex flex-column align-items-center">
    <div
      class="d-flex flex-wrap align-items-center justify-content-evenly gap-5 mt-4 mb-4 genreWrapper"
    >
      <div
        class="genreCard point"
        routerLink="/genre/genre-details/{{ item.slug }}"
        role="link"
        *ngFor="let item of genrelist"
      >
        <img loading="lazy" [src]="item.pic_urls" alt="image" />
        <div class="d-flex flex-column gap-3 px-3 py-2 details">
          <div
            class="d-flex flex-row justify-content-between align-items-center"
          >
            <div class="genreName">{{ item.genre }}</div>
            <div style="color: #32a071">&#8377;{{ item.discount_cost }}</div>
          </div>
          <div class="detailsWrap w-100">
            <h3 class="cardHeading w-100">
              {{ item.name }}
            </h3>
            <div class="description vtext1">{{ item.short_description }}</div>
          </div>
          <div style="color: #afafaf">{{ item.total_lesson }} Lesson</div>
        </div>
      </div>
    </div>
  </div>
</div>
